/* tslint:disable */
/* eslint-disable */
/**
 * Syte Products API
 * API services for CRA, Files, and Collaborators
 *
 * The version of the OpenAPI document: v0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CdmaOverallSummaryFromJSON, CdmaOverallSummaryToJSON, } from './CdmaOverallSummary';
import { CdmaSafeguardDtoFromJSON, CdmaSafeguardDtoToJSON, } from './CdmaSafeguardDto';
import { CdmaSafeguardSummaryFromJSON, CdmaSafeguardSummaryToJSON, } from './CdmaSafeguardSummary';
/**
 * @export
 */
export const SafeguardListResponseOrderByEnum = {
    FrameworkOrder: 'FRAMEWORK_ORDER',
    LargestImpact: 'LARGEST_IMPACT',
    MaximumImpact: 'MAXIMUM_IMPACT'
};
/**
 * Check if a given object implements the SafeguardListResponse interface.
 */
export function instanceOfSafeguardListResponse(value) {
    let isInstance = true;
    return isInstance;
}
export function SafeguardListResponseFromJSON(json) {
    return SafeguardListResponseFromJSONTyped(json, false);
}
export function SafeguardListResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'orderBy': !exists(json, 'orderBy') ? undefined : json['orderBy'],
        'safeguardGroupIdList': !exists(json, 'safeguardGroupIdList') ? undefined : json['safeguardGroupIdList'],
        'overallSummary': !exists(json, 'overallSummary') ? undefined : CdmaOverallSummaryFromJSON(json['overallSummary']),
        'safeguardSummary': !exists(json, 'safeguardSummary') ? undefined : CdmaSafeguardSummaryFromJSON(json['safeguardSummary']),
        'safeguardList': !exists(json, 'safeguardList') ? undefined : (json['safeguardList'].map(CdmaSafeguardDtoFromJSON)),
    };
}
export function SafeguardListResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'orderBy': value.orderBy,
        'safeguardGroupIdList': value.safeguardGroupIdList,
        'overallSummary': CdmaOverallSummaryToJSON(value.overallSummary),
        'safeguardSummary': CdmaSafeguardSummaryToJSON(value.safeguardSummary),
        'safeguardList': value.safeguardList === undefined ? undefined : (value.safeguardList.map(CdmaSafeguardDtoToJSON)),
    };
}
